document.addEventListener('DOMContentLoaded', function() {

    // ─── MARQUEE (vanilla JS infinite scroll) ───
    (function() {
        var track = document.getElementById('marqueeTrack');
        if (!track) return;

        // Wait for images to load so widths are correct
        var images = track.querySelectorAll('img');
        var loaded = 0;
        var total = images.length;

        function initMarquee() {
            var items = track.querySelectorAll('.marquee-item');
            // Measure one full set width
            var setWidth = 0;
            items.forEach(function(item) {
                setWidth += item.offsetWidth;
            });

            // Clone items until we have enough to fill 3x the viewport
            var viewportWidth = window.innerWidth;
            var clonesNeeded = Math.ceil((viewportWidth * 3) / setWidth);
            var originalHTML = track.innerHTML;
            var html = '';
            for (var i = 0; i < clonesNeeded + 1; i++) {
                html += originalHTML;
            }
            track.innerHTML = html;

            // Recalculate set width after cloning
            var allItems = track.querySelectorAll('.marquee-item');
            setWidth = 0;
            // Count original items
            var origCount = items.length;
            for (var j = 0; j < origCount; j++) {
                setWidth += allItems[j].offsetWidth;
            }

            // Animate
            var position = 0;
            var speed = 0.5; // px per frame

            function animate() {
                position -= speed;
                if (Math.abs(position) >= setWidth) {
                    position += setWidth;
                }
                track.style.transform = 'translateX(' + position + 'px)';
                requestAnimationFrame(animate);
            }
            requestAnimationFrame(animate);
        }

        if (total === 0) {
            initMarquee();
        } else {
            images.forEach(function(img) {
                if (img.complete) {
                    loaded++;
                    if (loaded === total) initMarquee();
                } else {
                    img.addEventListener('load', function() {
                        loaded++;
                        if (loaded === total) initMarquee();
                    });
                    img.addEventListener('error', function() {
                        loaded++;
                        if (loaded === total) initMarquee();
                    });
                }
            });
        }
    })();

    // ─── SMOOTH SCROLL ───
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

    // ─── INGREDIENT TABS (mobile only) ───
    (function() {
        var tabs = document.querySelectorAll('.ingredient-tab');
        var categories = document.querySelectorAll('.ingredient-category');
        if (!tabs.length || !categories.length) return;

        function isMobile() {
            return window.innerWidth <= 640;
        }

        /**
         * @param {string} tabName
         */
        function activateTab(tabName) {
            tabs.forEach(function(t) {
                t.classList.toggle('active', t.getAttribute('data-tab') === tabName);
            });
            categories.forEach(function(c) {
                c.classList.toggle('active', c.getAttribute('data-category') === tabName);
            });
        }

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                activateTab(this.getAttribute('data-tab') || 'rebuild');
            });
        });

        // On mobile, show first tab by default; on desktop show all
        function handleResize() {
            if (isMobile()) {
                // Activate the currently selected tab (or default to rebuild)
                var activeTab = document.querySelector('.ingredient-tab.active');
                activateTab(activeTab ? activeTab.getAttribute('data-tab') || 'rebuild' : 'rebuild');
            } else {
                // Show all categories on desktop
                categories.forEach(function(c) { c.classList.add('active'); });
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
    })();

    // ─── INGREDIENT CAROUSELS (desktop) ───
    (function() {
        var categories = document.querySelectorAll('.ingredient-category');
        if (!categories.length) return;

        categories.forEach(function(category) {
            if (!(category instanceof HTMLElement)) return;

            var carousel = category.querySelector('[data-ingredient-carousel]');
            var prevButton = category.querySelector('[data-ingredient-carousel-prev]');
            var nextButton = category.querySelector('[data-ingredient-carousel-next]');
            if (!(carousel instanceof HTMLElement) || !(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) return;

            var ingredientCarousel = /** @type {HTMLElement} */ (carousel);

            function getScrollDistance() {
                var firstCard = ingredientCarousel.querySelector('.ingredient-card, .cta-card');
                if (!(firstCard instanceof HTMLElement)) return ingredientCarousel.offsetWidth;

                var styles = window.getComputedStyle(ingredientCarousel);
                var gap = parseFloat(styles.columnGap || styles.gap || '0');
                return firstCard.offsetWidth + gap;
            }

            prevButton.addEventListener('click', function() {
                ingredientCarousel.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
            });

            nextButton.addEventListener('click', function() {
                ingredientCarousel.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
            });
        });
    })();

    // ─── CONTENT CAROUSELS (desktop + mobile) ───
    (function() {
        var carousels = document.querySelectorAll('.content-carousel');
        if (!carousels.length) return;

        carousels.forEach(function(carousel) {
            if (!(carousel instanceof HTMLElement)) return;

            var carouselTrack = carousel.querySelector('.content-carousel-track');
            if (!(carouselTrack instanceof HTMLElement)) return;

            var slides = carouselTrack.querySelectorAll('.content-slide');
            var prevButton = carousel.querySelector('[data-carousel-prev]');
            var nextButton = carousel.querySelector('[data-carousel-next]');
            if (!slides.length || !(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) return;

            var contentCarouselTrack = /** @type {HTMLElement} */ (carouselTrack);

            function getActiveIndex() {
                return Math.round(contentCarouselTrack.scrollLeft / contentCarouselTrack.offsetWidth);
            }

            /**
             * @param {number} index
             */
            function scrollToSlide(index) {
                var nextIndex = (index + slides.length) % slides.length;
                contentCarouselTrack.scrollTo({ left: nextIndex * contentCarouselTrack.offsetWidth, behavior: 'smooth' });
            }

            prevButton.addEventListener('click', function() {
                scrollToSlide(getActiveIndex() - 1);
            });

            nextButton.addEventListener('click', function() {
                scrollToSlide(getActiveIndex() + 1);
            });
        });
    })();

    // ─── PRODUCT CAROUSEL (mobile only, no content duplication) ───
    (function() {
        var carousel = document.getElementById('productCarousel');
        if (!(carousel instanceof HTMLElement)) return;

        var slides = carousel.querySelectorAll('.product-image');
        var prevButton = document.querySelector('[data-product-carousel-prev]');
        var nextButton = document.querySelector('[data-product-carousel-next]');
        if (!slides.length || !(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) return;

        var productCarousel = /** @type {HTMLElement} */ (carousel);

        function getActiveIndex() {
            return Math.round(productCarousel.scrollLeft / productCarousel.offsetWidth);
        }

        /**
         * @param {number} index
         */
        function scrollToSlide(index) {
            var nextIndex = (index + slides.length) % slides.length;
            productCarousel.scrollTo({ left: nextIndex * productCarousel.offsetWidth, behavior: 'smooth' });
        }

        prevButton.addEventListener('click', function() {
            scrollToSlide(getActiveIndex() - 1);
        });

        nextButton.addEventListener('click', function() {
            scrollToSlide(getActiveIndex() + 1);
        });
    })();
});
